import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import ProductEditFormImpl from './ProductEditFormImpl';
import ProductList from './ProductList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import ProductListView from './ProductListView'


export default function ProductDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.productDashboard);
  const [ productId, setProductId] = React.useState('');
  const [reloadProductList, setReloadProductList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <ProductEditFormImpl 
            setReloadProductList={setReloadProductList}
            productId={productId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <ProductListView 
                      setProductId = {setProductId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
